import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import * as yup from 'yup';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { regexEmail } from 'src/app/utils/validations';
import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';

const schema = yup.object().shape({
  email: yup
    .string()
    .email('Debes ingresar un correo electrónico válido')
    .matches(regexEmail, 'El correo es inválido')
    .required('El correo es requerido'),
});

const defaultValues = {
  email: '',
};

export const Capturer = ({ onCapture, isLoading, ...props }) => {
  const theme = useTheme();

  const { control, formState, handleSubmit, reset } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });

  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  return (
    <div {...props}>
      <Typography className="mt-32 text-4xl font-extrabold tracking-tight leading-tight">
        ¿Has olvidado tu contraseña?
      </Typography>
      <div className="flex items-baseline mt-2 font-medium">
        <Typography>Complete el formulario para restablecer su contraseña</Typography>
      </div>

      <form
        name="recoveryForm"
        noValidate
        className="flex flex-col justify-center w-full mt-32"
        onSubmit={handleSubmit(onCapture)}
      >
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              className="mb-24"
              label="Correo"
              type="email"
              error={!!errors.email}
              helperText={errors?.email?.message}
              variant="outlined"
              required
              fullWidth
            />
          )}
        />

        <Button
          variant="contained"
          color="secondary"
          className=" w-full mt-4"
          aria-label="Register"
          disabled={_.isEmpty(dirtyFields) || !isValid || isLoading}
          type="submit"
          size="large"
        >
          {isLoading ? <CircularProgress size="1.8rem" /> : 'Enviar'}
        </Button>

        <Typography
          className="mt-32 text-md font-medium text-center sm:text-start"
          color="text.secondary"
        >
          <span>Volver a </span>
          <Link className="ml-4" to="/sign-in" style={{ color: theme.palette.primary.main }}>
            Inicio de sesión
          </Link>
        </Typography>
      </form>
    </div>
  );
};
